// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
}

.section-one {
  background-color: 'red';
  position: relative;
  padding: 0 0 350px;
}
.section-one .section-one__title {
  color: #fff;
  font-size: 35px;
  margin-bottom: 30px;
  text-align: center;
}
.section-one .section-one__descr {
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  max-width: 300px;
  margin: 0 auto;
  text-align: center;
}

.section-two {
  background-color: var(--secondaryColor);
  position: relative;
  /* z-index: 10; */
}
.section-two .section-two__title {
  color: #fff;
  font-size: 35px;
  margin-bottom: 30px;
  text-align: center;
}

.section-two .section-two__descr {
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  max-width: 300px;
  margin: 0 auto;
  text-align: center;
}

/* -------------------------------------------------------------------------
     begin Separator
   * ------------------------------------------------------------------------- */
.separator {
  bottom: -4px;
  left: 0;
  overflow: hidden;
  position: absolute;

  width: 100%;
}

/* -------------------------------------------------------------------------
     end Separator
   * ------------------------------------------------------------------------- */

/* begin Media Max-Width 767
  ============================================================================ */

@media screen and (max-width: 767px) {
  .section-one {
    padding: 0px 0 150px;
  }
  .section-one .separator {
    bottom: -110px;
  }
  .section-one .separator .separator__svg {
    left: -20%;
    position: relative;
    transform: rotate(15deg);
    width: 140%;
  }
}

/* end Media Max-Width 767
  ============================================================================ */
`, "",{"version":3,"sources":["webpack://./src/css/dividerDiagonal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;gFAEgF;AAChF;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,kBAAkB;;EAElB,WAAW;AACb;;AAEA;;gFAEgF;;AAEhF;gFACgF;;AAEhF;EACE;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;EACb;AACF;;AAEA;gFACgF","sourcesContent":["body {\n  overflow-x: hidden;\n}\n\n.section-one {\n  background-color: 'red';\n  position: relative;\n  padding: 0 0 350px;\n}\n.section-one .section-one__title {\n  color: #fff;\n  font-size: 35px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n.section-one .section-one__descr {\n  color: #fff;\n  font-size: 16px;\n  line-height: 1.5;\n  max-width: 300px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.section-two {\n  background-color: var(--secondaryColor);\n  position: relative;\n  /* z-index: 10; */\n}\n.section-two .section-two__title {\n  color: #fff;\n  font-size: 35px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.section-two .section-two__descr {\n  color: #fff;\n  font-size: 16px;\n  line-height: 1.5;\n  max-width: 300px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n/* -------------------------------------------------------------------------\n     begin Separator\n   * ------------------------------------------------------------------------- */\n.separator {\n  bottom: -4px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n\n  width: 100%;\n}\n\n/* -------------------------------------------------------------------------\n     end Separator\n   * ------------------------------------------------------------------------- */\n\n/* begin Media Max-Width 767\n  ============================================================================ */\n\n@media screen and (max-width: 767px) {\n  .section-one {\n    padding: 0px 0 150px;\n  }\n  .section-one .separator {\n    bottom: -110px;\n  }\n  .section-one .separator .separator__svg {\n    left: -20%;\n    position: relative;\n    transform: rotate(15deg);\n    width: 140%;\n  }\n}\n\n/* end Media Max-Width 767\n  ============================================================================ */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
